import { Snackbar, Alert } from "@mui/material";
import { useError } from "../../contexts/ErrorContext";

export default function GlobalErrorSnackbar() {
	const { error, clearError } = useError();

	return (
		<Snackbar
			open={!!error}
			autoHideDuration={4000}
			onClose={clearError}
			anchorOrigin={{ vertical: "top", horizontal: "center" }}
		>
			<Alert onClose={clearError} severity="error" sx={{ width: "100%" }}>
				{error}
			</Alert>
		</Snackbar>
	);
}
